<script setup lang="ts">
const props = defineProps({
  color: { type: String, default: 'primary' },
  strokeWidth: { type: String, default: '2' },
});
</script>

<template>
  <ProgressSpinner
    aria-label="Loading"
    class="spinner-colors"
    :class="{
      'change-colors-contrast': props.color === 'contrast',
      'change-colors-primary': props.color === 'primary',
    }"
    :pt="{ root: { class: 'flex' } }"
    :strokeWidth="props.strokeWidth"
    animationDuration="5s"
  />
</template>

<style scoped>
.change-colors-contrast {
  --spinner-color: var(--p-primary-contrast-color);
}

.change-colors-primary {
  --spinner-color: var(--p-primary-color);
}
</style>
